import React from 'react';

interface SimpleGradientTextProps {
  children: string;
  animationSpeed?: number;
  colors?: string[];
  colorsString?: string;
  showBorder?: boolean;
  className?: string;
}

const SimpleGradientText: React.FC<SimpleGradientTextProps> = ({ 
  children, 
  animationSpeed = 8,
  colors = ['#40ffaa', '#4079ff', '#40ffaa', '#4079ff', '#40ffaa'],
  colorsString,
  showBorder = false,
  className = ''
}) => {
  // Parse colorsString if provided
  const finalColors = colorsString 
    ? colorsString.split(',').map(c => c.trim())
    : colors;
  const gradientStyle = {
    backgroundImage: `linear-gradient(to right, ${finalColors.join(', ')})`,
    animationDuration: `${animationSpeed}s`,
  };

  const containerStyle = {
    position: 'relative' as const,
    margin: '0 auto',
    display: 'flex',
    maxWidth: 'fit-content',
    flexDirection: 'row' as const,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '1.25rem',
    fontWeight: 700,
    backdropFilter: 'blur(10px)',
    transition: 'box-shadow 0.5s ease-out',
    overflow: 'hidden',
    cursor: 'pointer',
  };

  const overlayStyle = showBorder ? {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: '300% 100%',
    animation: `gradient linear infinite ${animationSpeed}s`,
    borderRadius: 'inherit',
    zIndex: 0,
    pointerEvents: 'none' as const,
    ...gradientStyle,
  } : {};

  const overlayBeforeStyle = showBorder ? {
    content: '""',
    position: 'absolute' as const,
    left: '50%',
    top: '50%',
    borderRadius: 'inherit',
    width: 'calc(100% - 2px)',
    height: 'calc(100% - 2px)',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#060010',
    zIndex: -1,
  } : {};

  const textStyle = {
    display: 'inline-block',
    position: 'relative' as const,
    zIndex: 2,
    backgroundSize: '300% 100%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    animation: `gradient linear infinite ${animationSpeed}s`,
    fontSize: 'clamp(1rem, 3vw, 2.5rem)',
    fontWeight: 700,
    ...gradientStyle,
  };

  return (
    <>
      <style>
        {`
          @keyframes gradient {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
      <div className={`animated-gradient-text ${className}`} style={containerStyle}>
        {showBorder && (
          <div style={overlayStyle}>
            <div style={overlayBeforeStyle}></div>
          </div>
        )}
        <div style={textStyle}>{children}</div>
      </div>
    </>
  );
};

export default SimpleGradientText;